import React, { useState } from "react";
import classnames from "classnames";
import { useUi } from "@jelly/lesson";
import RcSlider from "rc-slider";

import "rc-slider/assets/index.css";
import defaultStyle from "./Slider.module.scss";
import { Theme } from "@jelly/ui";

export interface SliderProps {
  className?: string;
  min?: number;
  max?: number;
  step?: number | null;
  defaultValue?: number;
  value?: number;
  customMarks?: Record<number, React.ReactNode>;
  marks?: string[];
  onBeforeChange?: (value: number) => void;
  onAfterChange?: (value: number) => void;
  onChange?: (value: number) => void;
  theme?: Theme;
  style?: Record<string, string>;
  vertical?: boolean;
  disabled?: boolean;
}

const Slider: React.FC<SliderProps> = (props) => {
  const { style = defaultStyle, theme = "default", className, ...restProps } = props;
  const { MathSvg } = useUi();
  const [active, setActive] = useState(props.defaultValue ? props.defaultValue - 1 : 0);

  const objectStyles = {
    handleStyle: {
      [props.vertical ? "left" : "top"]: "3px", // fix position
    },
  };

  function handleChange(value: number): void {
    setActive(value - 1);

    if (props.onChange) {
      props.onChange(value);
    }
  }

  function generateMarks(marks?: string[]): Record<number, React.ReactNode> | undefined {
    if (!marks) {
      return;
    }

    return marks.reduce<Record<number, React.ReactNode>>((acc, item, index) => {
      acc[index + 1] = (
        <label
          className={classnames(style.mark, {
            [style.activeMark]: index === active,
            [style.afterMark]: index > active,
          })}
        >
          <MathSvg formatter="html">{item}</MathSvg>
        </label>
      );
      return acc;
    }, {});
  }

  const marks = props.customMarks ?? generateMarks(props.marks);

  return (
    <RcSlider
      className={classnames(className, style[theme])}
      {...restProps}
      {...objectStyles}
      marks={marks}
      onChange={(value: number) => handleChange(value)}
    />
  );
};

export default Slider;
